<template>
  <div class="mapToolBox">
    <!-- 空间范围查询 -->
    <div class="toolLeft">
      <span>空间范围查询：</span>
      <div class="itemWrap" v-for="(item, index) in tipToolArray" :key="index">
        <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
          <el-button class="btnItemClass" circle @click.stop="tipToolClick(item.id)">
            <img class="imgItemClass" :src="item.iconSrc" alt="" :title="item.title" />
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <!-- 地图工具 -->
    <div class="toolRight">
      <div class="itemWrap" v-for="(item, index) in mapToolArray" :key="index">
        <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
          <el-button class="btnItemClass" circle @click.stop="mapToolClick(item.id)">
            <img class="imgItemClass" :src="item.iconSrc" alt="" />
          </el-button>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["mapobj", "mapqueryList"],
  data() {
    return {
    outLineIds: [],
    imageSourceIds:[],
      tipToolArray: [
        {
          id: "1",
          name: "圈选",
          iconSrc: require("../../../assets/imgs/mapIcon/quan.png"),
          title: "鼠标左键在地图上拖拽画圆",
        },
        {
          id: "2",
          name: "框选",
          iconSrc: require("../../../assets/imgs/mapIcon/kuang.png"),
          title: "鼠标左键在地图上拖拽画矩形",
        },
        {
          id: "3",
          name: "多边形选",
          iconSrc: require("../../../assets/imgs/mapIcon/duobian.png"),
          title: "鼠标左键在地图上拖拽画多边形",
        },
        {
          id: "4",
          name: "清除",
          iconSrc: require("../../../assets/imgs/mapIcon/clear.png"),
          title: "",
        },
      ],
      mapToolArray: [
        {
          id: "1",
          name: "恢复初始",
          iconSrc: require("../../../assets/imgs/mapIcon/mapHome.png"),
        },
        {
          id: "2",
          name: "放大",
          iconSrc: require("../../../assets/imgs/mapIcon/mapBig.png"),
        },
        {
          id: "3",
          name: "缩小",
          iconSrc: require("../../../assets/imgs/mapIcon/mapSmall.png"),
        },
      ],
    };
  },
  mounted() {
    console.log("工具组件获取数据", this.mapqueryList);
    setTimeout(() => {
      console.log("地图的图层数据", this.mapobj.getStyle());
    }, 300);
  },
  methods: {
    //  地图绘制点击触发
    tipToolClick(id) {
      switch (id) {
        case "1":
          this.handleMapQuanXuan();
          break;
        case "2":
            this.handleMapJuxingXuan();
          break;
        case "3":
            this.handleMapMoreXuan();
          break;
        case "4":
            this.hardClearMap();
          break;
        default:
          console.log("无此点击类型");
      }
    },
    // 地图工具点击触发
    mapToolClick(id) {
      switch (id) {
        case "1":
          //恢复初始状态
          this.mapobj.flyTo({
            center: [102, 37.94],
            zoom: 2.99998,
          });
          break;
        case "2":
          //放大
          this.mapobj.zoomIn();
          break;
        case "3":
          //缩小
          this.mapobj.zoomOut();
          break;
        default:
          console.log("无此点击类型");
      }
    },
    //  空间查询-圈选
    handleMapQuanXuan() {
      this.switchQTypeToSpace();
      let _this = this;
      this.seletorActive = "1";
      // 清除绘制残留
      console.log('开始圈选！');
      this.hardClearMap();
      var startPoint, endPoint, buffered, distance;
      var canvas = this.mapobj.getCanvasContainer();
      function onMove(e) {
        canvas.style.cursor = "crosshair";
        endPoint = turf.point(e.lngLat.toArray());
        distance = turf.distance(startPoint, endPoint, { units: "kilometers" });
        buffered = turf.circle(startPoint, distance, { units: "kilometers" });
        _this.mapobj.getSource("buffer").setData(buffered);
      }

      function onUp(e) {
        canvas.style.cursor = "";
        _this.mapobj.off("mousemove", onMove);
        _this.mapobj.off("mousedown", onDown);
        _this.seletorActive = "";
        endPoint = turf.point(e.lngLat.toArray());
        distance = turf.distance(startPoint, endPoint, { units: "kilometers" });
        buffered = turf.circle(startPoint, distance, { units: "kilometers" });
        //获取区域经纬度拼接
        _this.pointDataStr = "";
        buffered.geometry.coordinates[0].map((v, i) => {
          if (i < buffered.geometry.coordinates[0].length - 1) {
            _this.pointDataStr += v[0] + " " + v[1] + ",";
          } else {
            _this.pointDataStr += v[0] + " " + v[1];
          }
        });
        _this.qTypeFlag = 1;
        _this.tranferWkt();
      }

      function onDown(e) {
        this.collpseTableData = [];
        canvas.style.cursor = "crosshair";
        e.preventDefault();
        startPoint = turf.point(e.lngLat.toArray());
        buffered = turf.circle(startPoint, 0.1, { units: "kilometers" });
        if (!_this.mapobj.getLayer("buffer")) {
          _this.mapobj.addLayer({
            id: "buffer",
            type: "line",
            source: {
              type: "geojson",
              data: buffered,
            },
            layout: {},
            paint: {
              "line-color": "red",
              "line-width": 2,
            },
          });
        } else {
          _this.mapobj.getSource("buffer").setData(buffered);
        }
        _this.$store.dispatch("productSearch/updatePublicklayerid", "buffer");
        _this.mapobj.on("mousemove", onMove);
        _this.mapobj.once("mouseup", onUp);
      }

      this.mapobj.on("mousedown", onDown);
      canvas.style.cursor = "crosshair";
    },
    //  空间查询-框选
    handleMapJuxingXuan() {
      this.switchQTypeToSpace();
      let _this = this;
      this.seletorActive = "2";
      // 清除绘制残留
      this.hardClearMap();
      var startRec, leftBottom, rightTop, endRec, rectangle;
      var canvas = this.mapobj.getCanvasContainer();

      function onMove(e) {
        canvas.style.cursor = "crosshair";
        endRec = turf.point(e.lngLat.toArray()).geometry.coordinates;
        leftBottom = [startRec[0], endRec[1]];
        rightTop = [endRec[0], startRec[1]];
        rectangle = turf.polygon([[startRec, rightTop, endRec, leftBottom, startRec]]);
        _this.mapobj.getSource("buffer").setData(rectangle);
      }

      function onUp(e) {
        canvas.style.cursor = "";
        _this.mapobj.off("mousemove", onMove);
        _this.mapobj.off("mousedown", onDown);
        _this.seletorActive = "";
        _this.pointDataStr = "";
        //获取区域经纬度拼接
        rectangle.geometry.coordinates[0].map((v, i) => {
          if (i < rectangle.geometry.coordinates[0].length - 1) {
            _this.pointDataStr += v[0] + " " + v[1] + ",";
          } else {
            _this.pointDataStr += v[0] + " " + v[1];
          }
        });

        _this.qTypeFlag = 1;
        _this.tranferWkt();
        //调取空间查询接口
      }

      function onDown(e) {
        this.collpseTableData = [];
        canvas.style.cursor = "crosshair";
        e.preventDefault();
        startRec = turf.point(e.lngLat.toArray()).geometry.coordinates;
        endRec = turf.point(e.lngLat.toArray()).geometry.coordinates;
        leftBottom = [startRec[0], endRec[1]];
        rightTop = [endRec[0], startRec[1]];
        rectangle = turf.polygon([[startRec, rightTop, endRec, leftBottom, startRec]]);
        if (!_this.mapobj.getLayer("buffer")) {
          _this.mapobj.addLayer({
            id: "buffer",
            type: "line",
            source: {
              type: "geojson",
              data: rectangle,
            },
            layout: {},
            paint: {
              "line-color": "red",
              "line-width": 2,
            },
          });
        } else {
          _this.mapobj.getSource("buffer").setData(rectangle);
        }
        _this.$store.dispatch("productSearch/updatePublicklayerid", "buffer");
        _this.mapobj.on("mousemove", onMove);
        _this.mapobj.once("mouseup", onUp);
      }
      this.mapobj.on("mousedown", onDown);
      canvas.style.cursor = "crosshair";
    },
    // 空间查询-多边形
    handleMapMoreXuan() {
      //多边形空间选择
      this.switchQTypeToSpace();
      let _this = this;
      this.seletorActive = "3";
      // 清除绘制残留
      this.hardClearMap();
      var line, polygon;
      var theArr = [];
      var canvas = this.mapobj.getCanvasContainer();

      function ondblclick(e) {
        _this.mapobj.removeLayer("polygonLine");
        _this.mapobj.removeSource("polygonLine");
        _this.mapobj.off("mousemove", onMove);
        _this.mapobj.off("click", onDown);
        canvas.style.cursor = "";
        _this.seletorActive = "";
        theArr = [];
        _this.pointDataStr = "";
        //获取区域经纬度拼接
        const coordinatesData = polygon.geometry.coordinates[0] || [];
        let beforeCoordinate = [];
        let dataLength = coordinatesData.length || 0;
        for (let i = 0; i < dataLength; i++) {
          let data = coordinatesData[i];
          if (data[0] == beforeCoordinate[0] && data[1] == beforeCoordinate[1]) {
            // 去重
            continue;
          } else {
            beforeCoordinate = data;
            if (i < dataLength - 1) {
              _this.pointDataStr += data[0] + " " + data[1] + ",";
            } else {
              _this.pointDataStr += data[0] + " " + data[1];
            }
          }
        }
        //调取空间查询接口
        _this.qTypeFlag = 1;
        _this.tranferWkt();
      }

      function onMove(e) {
        canvas.style.cursor = "crosshair";
        theArr[theArr.length - 1] = e.lngLat.toArray();
        line = turf.lineString(theArr);
        console.log(theArr);
        _this.mapobj.getSource("polygonLine").setData(line);
      }

      function onDown(e) {
        //生成面的坐标
        if (theArr.length >= 2) {
          theArr.splice(theArr.length - 1, 0, e.lngLat.toArray());
        } else {
          theArr.push(e.lngLat.toArray());
          theArr.push(e.lngLat.toArray());
        }
        line = turf.lineString(theArr);
        //绘制线
        if (!_this.mapobj.getLayer("polygonLine")) {
          _this.mapobj.addLayer({
            id: "polygonLine",
            type: "line",
            source: {
              type: "geojson",
              data: line,
            },
            layout: {},
            paint: {
              "line-color": "red",
              "line-width": 2,
            },
          });
        } else {
          _this.mapobj.getSource("polygonLine").setData(line);
        }
        //绘制面
        if (theArr.length > 3) {
          polygon = turf.lineToPolygon(line);
          if (!_this.mapobj.getLayer("buffer")) {
            _this.mapobj.addLayer({
              id: "buffer",
              type: "line",
              source: {
                type: "geojson",
                data: polygon,
              },
              layout: {},
              paint: {
                "line-color": "red",
                "line-width": 2,
              },
            });
          } else {
            _this.mapobj.getSource("buffer").setData(polygon);
          }
        }
        _this.$store.dispatch("productSearch/updatePublicklayerid", "buffer");
        _this.mapobj.on("mousemove", onMove);
        _this.mapobj.once("dblclick", ondblclick);
      }

      this.mapobj.on("click", onDown);
      canvas.style.cursor = "crosshair";
    },
    //清除图层
    clearLayer(layerId) {
      
      if (!this.mapobj.getLayer(layerId)) {
      } else {
        this.mapobj.removeLayer(layerId);
      }
      if (!this.mapobj.getSource(layerId)) {
      } else {
        this.mapobj.removeSource(layerId);
      }
    },
    switchQTypeToSpace() {
      this.qTypeFlag = 1;
      this.currWkt = "POLYGON ((" + this.pointDataStr + "))";
    },
    tranferWkt() {
      this.$store.dispatch("productSearch/updatePublickBtntype", "3");
      if (this.pointDataStr != "") {
        this.currWkt = "POLYGON ((" + this.pointDataStr + "))";
        this.$store.dispatch("productSearch/updatePublickCode", this.currWkt);
        this.searchfn(this.currWkt);
      }
    },
    // 清除全部
    hardClearMap() {
      this.$emit('clearImgsId','1');
      // 初始化
      this.currWkt = "";
      this.$store.dispatch("productSearch/updatePublicklayerid", this.currWkt);
    },
    // 触发查询影像
    searchfn(wkt) {
      let params = {
        //   "produceStartTime": this.$store.state.dataQueryFenJing.startTime_cj,
        //   "produceEndTime": this.$store.state.dataQueryFenJing.endTime_cj,
        //   "timeType": this.$store.state.dataQueryFenJing.dateType,//时间类型
        //   "type": this.$store.state.dataQueryFenJing.dataBatch,//数据批次
        //   "resolution": this.$store.state.dataQueryFenJing.resolution,//分辨率
        //   "resolutionType": this.$store.state.dataQueryFenJing.fenbianlvType,//分辨率类型 2其他 1正常，可多选
          "wkt": wkt,
        //   "pageNumber": 1,
        //   "pageSize": 10,
      };
      this.$emit('parentData', params);
    },
  },
};
</script>

<style lang="scss" scoped>
.mapToolBox {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 999;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: rgb(54, 54, 54);
  line-height: 30px;
  .toolLeft {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: rgba($color: #ffffff, $alpha: 0.6);
    border-radius: 50px;
    padding: 5px 15px;
    .btnItemClass {
      padding: 8px !important;
      margin-right: 4px;
      .imgItemClass {
        width: 20px;
        height: 20px;
      }
    }
  }
  .toolRight {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: rgba($color: #ffffff, $alpha: 0.6);
    border-radius: 50px;
    padding: 5px 15px;
    margin-left: 20px;
    .btnItemClass {
      padding: 8px !important;
      margin-right: 4px;
      .imgItemClass {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
